// src/pages/ThesisPage.js
import React from 'react';
import ThesisCard from '../components/ThesisCard';
import thesisData from '../data/thesis.json';
import '../styles/ThesisPage.css';

const ThesisPage = () => {
  return (
    <div className="thesis-page">
      <h1>Available Undergraduate and Master's Theses</h1>
      <br></br>
      {/* Lista de tesis */}
      <div className="thesis-grid">
        {thesisData.length > 0 ? (
          thesisData.map((thesis) => (
            <ThesisCard
              key={thesis.id}
              isAssigned={thesis.isAssigned}
              mailto={thesis.mailto}
              thesisName={thesis.thesisName}
              thesisDirectors={thesis.thesisDirectors}
              researchAreas={thesis.researchAreas}
              usefulLinks={thesis.usefulLinks}
              thesisSummary={thesis.thesisSummary}
            />
          ))
        ) : (
          <><p>We will be posting all available theses soon.</p><p>Stay tuned.</p></>
        )}
      </div>
    </div>
  );
};

export default ThesisPage;
